/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  imports: [NgSelectModule, CommonModule, ReactiveFormsModule],
  standalone: true,
  selector: 'formly-field-multiselect',
  template: `
    <div class="mb-3">
      <label [attr.for]="id" class="form-label">
        {{ props.label }}
        <span *ngIf="props.required" aria-hidden="true">*</span>
      </label>
      <ng-select
        [multiple]="true"
        [items]="options$ | async"
        [placeholder]="props.placeholder ?? ''"
        [formControl]="$any(formControl)"
        bindLabel="name"
      >
      </ng-select>
    </div>
  `,
})
export class FormlyFieldMultiSelect extends FieldType implements OnDestroy, OnInit {
  onDestroy$ = new Subject<void>();
  options$: any;

  ngOnInit() {
    this.options$ = this.to.options;
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}
